import { useMutation } from '@tanstack/react-query'

import { settingsApi } from '../../settings/api/settingsApi'
import type { TEditAccountSettingsPayload } from '../../settings/api/types/editAccountSettings.types'

type TSettingsPayload = Pick<TEditAccountSettingsPayload, 'gender' | 'birthdate' | 'location'>

export const useWizardSettingsMutation = () =>
  useMutation({
    mutationFn: (payload: TSettingsPayload) => settingsApi.editAccountSettings(payload),
  })
